module.exports = __webpack_public_path__ + "img/sl_long_wait.5269c584.png";